/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppConfig } from '../../models/app-config';

export interface ListAppConfigs$Params {}

export function listAppConfigs(
  http: HttpClient,
  rootUrl: string,
  params?: ListAppConfigs$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<AppConfig>>> {
  const rb = new RequestBuilder(rootUrl, listAppConfigs.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AppConfig>>;
    })
  );
}

listAppConfigs.PATH = '/app-configs';
